import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import axios from "axios";
import { Newspaper } from "lucide-react";
import { API } from "@/lib/auth";
import { Skel } from "@/components/market/Shared";

export const DailyBriefing = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/ai/briefing`, { timeout: 90000 }).then((r) => setD(r.data)).catch(() => setD({ error: true })); }, []);
  if (d?.error) return null;
  return (
    <section className="glass p-5 sm:p-6" data-testid="daily-briefing">
      <h3 className="font-head font-semibold flex items-center gap-2"><Newspaper className="w-4 h-4 text-[var(--violet)]" />Today's AI briefing</h3>
      {!d ? <Skel h="h-32" /> : <>
        <div className="ai-md text-sm text-slate-300 leading-relaxed mt-3" data-testid="daily-briefing-text"><ReactMarkdown>{d.text}</ReactMarkdown></div>
        <div className="text-[11px] text-slate-500 mt-3 font-num">{d.date} · written by ChatGPT ({d.model}) from live app data · not financial advice</div></>}
    </section>
  );
};
